import { Platform } from 'react-native';
export const isIOS = Platform.OS === 'ios';
export const isAndroid = Platform.OS === 'android';
export const isNative = isIOS || isAndroid;
export const isWeb = Platform.OS === 'web';
// RNWV is set via injectedJavaScriptBeforeContentLoaded as a reliable flag;
// ReactNativeWebView can be missing at module-eval time on some WebView versions.
export const isWebView = isWeb &&
    typeof window !== 'undefined' &&
    ('ReactNativeWebView' in window || window.RNWV === true);
export const isMac = /Mac|iPhone|iPod|iPad/.test(typeof navigator !== 'undefined' ? navigator.userAgent : '');
export const isBrowser = isWeb && !isWebView;
const Env = !isWebView
    ? { OS: Platform.OS }
    : JSON.parse(window.ReactNativeWebView?.injectedObjectJson() ?? '{}');
export const isIosWV = isWebView && Env.OS === 'ios';
export const isAndroidWV = isWebView && Env.OS === 'android';
